import { render, staticRenderFns } from "./VasionCalendar.vue?vue&type=template&id=363a8099&scoped=true&"
import script from "./VasionCalendar.vue?vue&type=script&lang=js&"
export * from "./VasionCalendar.vue?vue&type=script&lang=js&"
import style0 from "./VasionCalendar.vue?vue&type=style&index=0&id=363a8099&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a8099",
  null
  
)

export default component.exports